export default __webpack_public_path__ + "static/media/back_ins.39fc21da.svg";